var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { Button } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
var StyledPythonError = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: #f23535;\n  border-style: solid;\n  border-radius: 7px;\n  margin-top: 4px;\n  padding: 10px;\n  width: auto;\n"], ["\n  border-color: #f23535;\n  border-style: solid;\n  border-radius: 7px;\n  margin-top: 4px;\n  padding: 10px;\n  width: auto;\n"])));
var PythonError = function (_a) {
  var error = _a.error,
    trace = _a.trace;
  var _b = useState(false),
    showTrace = _b[0],
    setShowTrace = _b[1];
  var t = useTranslation()[0];
  return React.createElement(StyledPythonError, null, React.createElement("pre", {
    style: {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word"
    }
  }, error), trace.length > 0 ? React.createElement(Button, {
    onClick: function () {
      return setShowTrace(!showTrace);
    },
    variant: "contained",
    "data-cy": "show-trace-button"
  }, showTrace ? t("hideFunctionCalls") : t("showFunctionCalls")) : null, showTrace && React.createElement("ol", null, trace.map(function (x, i) {
    return React.createElement("li", {
      key: i
    }, x);
  })));
};
export default PythonError;
var templateObject_1;